import { $ } from './utils';

document.addEventListener('DOMContentLoaded', () => {
    const collapseButton = $('#cross_icon');
    const collapseContent = $('#seo_accordion--content');

    if (collapseButton) {
        collapseButton.addEventListener('click', () => {
            if (collapseContent.classList.contains('is-active')) {
                collapseContent.classList.remove('is-active');
                collapseButton.classList.remove('is-active');
            } else {
                collapseContent.classList.add('is-active');
                collapseButton.classList.add('is-active');
            }
        });
    }
});
